import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { SUPPORTED_LANGUAGES } from './data/supportedLanguages';

import enHome from './locales/en/home.json';
import enLanding from './locales/en/landing.json';
import enCommon from './locales/en/common.json';

import esLanding from './locales/es/landing.json';
import esCommon from './locales/es/common.json';
import frLanding from './locales/fr/landing.json';
import frCommon from './locales/fr/common.json';
import deLanding from './locales/de/landing.json';
import deCommon from './locales/de/common.json';
import itLanding from './locales/it/landing.json';
import itCommon from './locales/it/common.json';
import ptLanding from './locales/pt/landing.json';
import ptCommon from './locales/pt/common.json';
import nlLanding from './locales/nl/landing.json';
import nlCommon from './locales/nl/common.json';
import plLanding from './locales/pl/landing.json';
import plCommon from './locales/pl/common.json';
import trLanding from './locales/tr/landing.json';
import trCommon from './locales/tr/common.json';
import ruLanding from './locales/ru/landing.json';
import ruCommon from './locales/ru/common.json';
import ukLanding from './locales/uk/landing.json';
import ukCommon from './locales/uk/common.json';
import svLanding from './locales/sv/landing.json';
import svCommon from './locales/sv/common.json';
import noLanding from './locales/no/landing.json';
import noCommon from './locales/no/common.json';
import daLanding from './locales/da/landing.json';
import daCommon from './locales/da/common.json';

type LandingJson = typeof enLanding;
type CommonJson = typeof enCommon;

const landingByLang: Record<string, LandingJson> = {
  en: enLanding,
  es: esLanding,
  fr: frLanding,
  de: deLanding,
  it: itLanding,
  pt: ptLanding,
  nl: nlLanding,
  pl: plLanding,
  tr: trLanding,
  ru: ruLanding,
  uk: ukLanding,
  sv: svLanding,
  no: noLanding,
  da: daLanding,
};

const commonByLang: Record<string, CommonJson> = {
  en: enCommon,
  es: esCommon,
  fr: frCommon,
  de: deCommon,
  it: itCommon,
  pt: ptCommon,
  nl: nlCommon,
  pl: plCommon,
  tr: trCommon,
  ru: ruCommon,
  uk: ukCommon,
  sv: svCommon,
  no: noCommon,
  da: daCommon,
};

const resources: Record<
  string,
  { home?: typeof enHome; landing?: LandingJson; common: CommonJson }
> = {
  en: { home: enHome, landing: enLanding, common: enCommon },
};

for (const lang of SUPPORTED_LANGUAGES) {
  const landing = landingByLang[lang.lang];
  const common = commonByLang[lang.lang];
  if (!common) continue;
  resources[lang.lang] = {
    ...(resources[lang.lang] ?? {}),
    common,
    ...(landing ? { landing } : {}),
  };
}

void i18n.use(initReactI18next).init({
  resources,
  lng: 'en',
  fallbackLng: 'en',
  defaultNS: 'home',
  ns: ['home', 'landing', 'common'],
  interpolation: {
    escapeValue: false,
  },
  returnObjects: true,
});

export default i18n;
